import confetti from 'canvas-confetti';

/**
 * Approach borrowed from https://www.kirilv.com/canvas-confetti/
 */

const defaultOptions = {
  disableForReducedMotion: true,
};

const starOptions = {
  ...defaultOptions,
  spread: 360,
  ticks: 50,
  gravity: 0,
  decay: 0.94,
  startVelocity: 30,
  shapes: ['star'],
  colors: ['FFE400', 'FFBD00', 'E89400', 'FFCA6C', 'FDFFB8'],
};

function shoot(options = {}) {
  confetti({
    ...starOptions,
    particleCount: 40,
    scalar: 1.2,
    shapes: ['star'],
    ...options,
  });

  confetti({
    ...starOptions,
    particleCount: 10,
    scalar: 0.75,
    shapes: ['circle'],
    ...options,
  });
}

export function basicCannon(options = {}) {
  confetti({
    ...defaultOptions,
    particleCount: 100,
    spread: 70,
    ...options,
  });
}

export function stars(options = {}) {
  setTimeout(() => shoot(options), 0);
  setTimeout(() => shoot(options), 100);
  setTimeout(() => shoot(options), 200);
}
